<template>
  <div class="schedule-wrap">
    <div class="nav-section">
      <div>
        <label class="label"> {{name}} </label>
        <strong>{{title}}</strong>
      </div>
      <van-icon name="search"/>
    </div>
    <div class="tab">
      <div>
        <span :class="{'active': activeTab == 0}" @click="activeTab = 0">日历</span>
        <span :class="{'active': activeTab == 1}" @click="activeTab = 1">会议室</span>
      </div>
      <van-icon class="icon" name="notes-o" />
    </div>
    <my-calender
      v-if="activeTab === 0"
      @change="changeTitle"
    />
    <div v-else>暂无内容</div>
    <!-- 底部列表 -->
    <div class="scroll-list-wrap">
      <div ref="list-item" class="list-item" v-for="(item, index) in bottomList" :key="JSON.stringify(index)">
        <div class="item-title">{{ item.itemTitle }}</div>
        <div class="sub-list" v-for="sub in item.weekList" :key="JSON.stringify(sub)">
          <!-- 今天 -->
          <div v-if="sub.type === 's' && sub.isToday" class="sub-today">
            <div class="left-wrap">
              <div>{{ '周' + dayMap[sub.mo.day()] }}</div>
              <div>{{ sub.mo.date() }}</div>
              <div>{{ getLunar(sub.mo) }}</div>
            </div>
            <div class="right-wrap">
              <div v-if="!sub.detail" class="detail-empty">
                暂无日程安排，<span class="btn" @click="initDraw">点击创建</span>
              </div>
              <div v-else class="detail">
                <div>{{ sub.detail.title }}</div>
                <div>{{ sub.detail.time }}</div>
              </div>
              <div class="bottom-line"></div>
            </div>
          </div>
          <!-- 非今天 -->
          <div v-if="sub.type === 's' && !sub.isToday" class="sub-today">
            <div class="left-wrap notToday">
              <div>{{ '周' + dayMap[sub.mo.day()] }}</div>
              <div>{{ sub.mo.date() }}</div>
              <div>{{ getLunar(sub.mo) }}</div>
            </div>
            <!-- 今天 -->
            <div class="right-wrap notToday">
              <!-- 没有日程 -->
              <div v-if="!sub.detail" class="detail-empty">
                暂无日程安排，<span class="btn" @click="initDraw">点击创建</span>
              </div>
              <!-- 有日程 -->
              <div v-else class="detail">
                <div>{{ sub.detail.title }}</div>
                <div>{{ sub.detail.time }}</div>
              </div>
            </div>
          </div>
          <div v-else class="week-sub">
            {{ sub.text }}
          </div>
        </div>
      </div>
    </div>
    <create-drawer :active-date="activeDate" ref="drawer" @save="saveCacheForm" />
  </div>
</template>
<script>
import moment from 'moment'
import {getUserInfo} from '../utils/service'
import MyCalender from '../components/schedule-list/my-calender.vue'
import calendar from 'solarday2lunarday'
import CreateDrawer from '../components/schedule-list/create-drawer.vue'
export default {
  components: {
    MyCalender,
    CreateDrawer
  },
  data () {
    return {
      name: '名称',
      list: [],
      activeDate: moment(Date.now()),
      activeTab: 0,
      bottomList: [],
      cacheForm: {
      },
      dayMap: {
        0: '日',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六'
      }
    }
  },
  computed: {
    title: {
      get () {
        return `${moment(this.activeDate).year()}年${moment(this.activeDate).month() + 1}月`
      },
      set () {

      }
    }
  },
  watch: {
    activeDate (newVal) {
      this.title = `${moment(this.activeDate).year()}年${moment(this.activeDate).month() + 1}月`
    }
  },
  created () {
    getUserInfo().then(res => {
      let {name, list} = res.data
      this.name = name
      this.list = list
      console.log('---->', res.data)
    })
    // 根据当前日期动态计算13个月数据
    // this.nowToDateList()

    // delter
    // this.$nextTick(() => {
    //   this.$refs['drawer'].init()
    // })
  },
  mounted () {
    // this.scrollToView()
  },
  methods: {
    saveCacheForm (obj) {
      this.cacheForm[this.activeDate.clone().format('YYYY-MM-DD')] = obj
      this.nowToDateList()
    },
    initDraw () {
      this.$refs['drawer'].init()
    },
    getLunar (mo) {
      return calendar.solar2lunar(mo.clone().format('YYYY-MM-DD')).IDayCn
    },
    changeTitle (date) {
      this.activeDate = moment(date).clone()
      console.log(this.activeDate)
      this.nowToDateList()
      this.$nextTick(() => {
        this.scrollToView()
      })
      // console.log('1', this.activeDate)
      // this.title = `${moment(this.activeDate).year()}年${moment(this.activeDate).month() + 1}月`
    },
    moToListObj (mo) {
      const weekList = []
      const tempObj = {}
      let days = Array(mo.daysInMonth()).fill(1) //
      // 将该月所有天数转成mo对象
      days = days.map((d, index) => mo.clone().startOf('month').add(index, 'd'))
      // 开始从每一天遍历生成周列表
      days.forEach((d, index) => {
        const week = d.week()
        const month = d.month()
        const day = d.date()
        if (d.clone().startOf('week').month() !== d.month()) {
          // 处理不在本月周的日期， 处理显示在前面的日程
          // console.log(d.format('YYYY-MM-DD'))
          if (this.activeDate.format('YYYY-MM-DD') === d.format('YYYY-MM-DD')) {
            weekList.push({
              type: 's',
              isToday: d.clone().isSame(moment(), 'day'),
              detail: this.cacheForm[d.format('YYYY-MM-DD')] ? this.cacheForm[d.format('YYYY-MM-DD')] : null,
              mo: this.activeDate.clone()
            })
          }
        } else {
          tempObj[`第${week}周`] = tempObj[`第${week}周`] ? [tempObj[`第${week}周`][0], `${month + 1}月${day}日`, [...tempObj[`第${week}周`][2], d]] : [`${month + 1}月${day}日`, `${month + 1}月${day}日`, [d]]
        }
        if (index === days.length - 1) {
          // 最后一个特殊处理
          if (d.clone().endOf('week').isAfter(d)) {
            tempObj[`第${week}周`][1] = `${d.clone().endOf('week').month() + 1}月${d.clone().endOf('week').date()}日`
          }
        }
      })
      // 添加周的List
      Object.keys(tempObj).forEach(item => {
        weekList.push({
          type: 'c',
          text: `${item}，${tempObj[item][0]} - ${tempObj[item][1]}`,
          mo: tempObj[item][2]
        })
      })
      // 在添加日程的list
      weekList.forEach((w, index, arr) => {
        if (w.type === 'c') {
          w.mo.forEach(d => {
            if (this.activeDate.format('YYYY-MM-DD') === d.format('YYYY-MM-DD')) {
              // console.log(d.format('YYYY-MM-DD'), this.cacheForm)
              arr.splice(index + 1, 0, {
                type: 's',
                isToday: d.clone().isSame(moment(), 'day'),
                detail: this.cacheForm[d.format('YYYY-MM-DD')] ? this.cacheForm[d.format('YYYY-MM-DD')] : null,
                mo: this.activeDate.clone()
              })
            }
          })
        }
      })
      return {
        mo,
        itemTitle: mo.year() === moment().year() ? `${mo.month() + 1}月` : `${mo.year()}年${mo.month() + 1}月`,
        weekList
      }
    },
    nowToDateList () {
      const arr = Array(12).fill(1)
      const res = [this.activeDate.clone()]
      const half = arr.length / 2
      arr.forEach((item, index) => {
        if (index < half) {
          const mo = this.activeDate.clone().subtract(index + 1, 'M')
          const obj = this.moToListObj(mo)
          res.unshift(obj)
        } else {
          const mo = this.activeDate.clone().add(index - half + 1, 'M')
          const obj = this.moToListObj(mo)
          res.push(obj)
        }
      })
      res[half] = this.moToListObj(res[half])
      console.log(res)
      this.bottomList = res
      // console.log(this.activeDate.startOf('month').startOf('week'), this.activeDate)
    },
    scrollToView () {
      // console.log(this.$refs['list-item'])
      this.$refs['list-item'][6].scrollIntoView({
        behavior: 'smooth'
      })
    }
  },
  filters: {
    dateFormat (str) {
      return moment(str)
    }
  }
}
</script>
<style lang="less" scoped>
  .schedule-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .scroll-list-wrap {
      flex: 1;
      overflow: auto;
      .list-item {
        padding: 16px 12px 0;
        .item-title {
          text-align: left;
          font-size: 18px;
          font-weight: bold;
          padding-bottom: 10px;
        }
        .sub-list {
          .week-sub {
            text-align: left;
            font-size: 12px;
            color: #999;
            line-height: 42px;
            // padding: 8px;
            padding-left: 52px
          }
          .sub-today {
            display: flex;
            .left-wrap {
              padding-right: 8px;
              display: flex;
              flex-direction: column;
              font-size: 12px;
              line-height: 22px;
              color: #426bef;
              font-weight: bold;
              div:nth-of-type(2) {
                font-size: 20px;
              }
              &.notToday {
                color: #000;
                div:nth-of-type(3) {
                  color: #999;
                }
              }
            }
            .right-wrap {
              flex: 1;
              padding-bottom: 3px;
              margin-left: 8px;
              display: flex;
              flex-direction: column;
              .bottom-line {
                height: 1px;
                background: rgb(236, 24, 24);
                position: relative;
                margin-bottom: 10px;
                &::before {
                  content: '';
                  width: 6px;
                  height: 6px;
                  border-radius: 50%;
                  background: rgb(236, 24, 24);
                  position: absolute;
                  left: 0px;
                  top: 50%;
                  transform: translateY(-50%);
                }
              }
              .detail {
                background: #e7eeff;
                border-radius: 4px;
                flex: 1;
                margin-bottom: 4px;
                margin-left: 4px;;
                text-align: left;
                border-left: 3px solid #5880f6;
                padding-left: 8px;
                padding-top: 4px;
                font-size: 14px;
                color: #3f5ba9;
                font-weight: 600;
                div:nth-child(2) {
                  font-size: 12px;
                  line-height: 20px;
                  font-weight: normal;
                  // transform: scale(.8);
                }
              }
              .detail-empty {
                flex: 1;
                display: flex;
                font-size: 12px;
                text-align: left;
                padding-left: 12px;
                padding-bottom: 8px;
                color: #999;
                align-items: center;
                .btn {
                  color: #426bef;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
  .nav-section {
    padding: 10px 10px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .label {
      width: 34px;
      height: 34px;
      display: inline-block;
      border-radius: 50%;
      background: #e48d38;
      color: #fff;
      font-size: 12px;
      line-height: 34px;
      // transform: scale(.8);
    }
    strong {
      font-size: 20px;
      display: inline-block;
      transform: translateY(2px);
    }
  }
  .tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 28px;
    border-bottom: 1px solid #e3e3e3;
    text-align: left;
    padding: 0 12px;
    span {
      display: inline-block;
      margin-right: 8px;
      &.active {
        border-bottom: 1.5px solid #426bef;
        border-radius: 1px;

        // width: 100%;
        // // position: absolute;
        // // bottom: 15px;
        // // left: 0;
        // z-index: 1;
        // width: 40px;
        // height: 3px;
        // background-color: #ee0a24;
        // border-radius: 3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/schedule-list.vue